import PerfectScrollbar from 'perfect-scrollbar';
export default function () {
    const $btnDownload = $('.download-tis');
    const $modalHtml = $('template').html();

    $btnDownload.each(function () {
        $(this).on('click', e => {
            e.preventDefault();
            $('html, body').css('overflow', 'hidden');
            $('body').prepend($modalHtml);
            new PerfectScrollbar('.modal-window .content', {
                swipeEasing: true
            });
            $('.wrapper-overlay').on('click', hiddeModal);
            $('.wrapper-overlay .close > .fa-times').on('click', hiddeModal);
            $('#access').on('change', checkedDownload);
        });
    });
}

function checkedDownload() {
    if ($(this).prop('checked')) {
        $('#download').attr('disabled', false);
    } else {
        $('#download').attr('disabled', true);
    }
}

function hiddeModal(e) {
    const $overlay = $('.wrapper-overlay');
    if (e.target !== this) return;
    $('html, body').css('overflow', 'auto');
    $overlay.remove();
    $(this).off('click', hiddeModal);
    $('#access').off('change', checkedDownload);
}